var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"medal-queue full",attrs:{"name":"screen-drawer"}},[(_vm.medal)?_c('medal-popup',{key:_vm.medal._id,attrs:{"data":_vm.medal}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }